import { AdfiUtil } from '@Components/util/adfi-util';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormComponent } from '@Components/ui/form/form.component';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { AdfiGrowlService } from '@services/adfi-growl.service';
import { LoadingService } from '@services/loading.service';
import { ActivatedRoute } from '@angular/router';
import { AdfiService } from '@services/adfi-service';
import { ENUM_ACTIONS, DataEntity, PropertyTypes, PeriodState, Permission, Property } from '@Interfaces/index';
import { ListComponent } from '@Components/ui/list/list.component';
import { AbstractControl, FormBuilder, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogData } from '@Components/ui/confirm-dialog/confirm-dialog.component';
import { NavRouteService } from '@services/nav-routing-service';

@Component({
  selector: 'app-form-assets',
  templateUrl: './form-assets.component.html',
  styleUrls: ['./form-assets.component.scss']
})
export class FormAssetsComponent implements OnInit {
  @ViewChild('assets') assetsTable: ListComponent;
  @Output() reloadData: EventEmitter<boolean> = new EventEmitter();

  id: any;
  masterId: any;
  paymentOrder: any;
  totalAsset: number = 0;
  availableBalance: number = 0;
  isConsumption = false;
  isLoading = false;
  canUploadCertificate = false;
  formAssets: FormGroup;
  listTypesProduct: any[];
  listTypesProductFiltered: any[];
  listAccounts: any[];
  listHeadquarters: any[];
  listMarks: any[];
  listMarksFiltered: any[];
  canAdd = false;
  canGenerate = false;
  value: number;
  assetId: number;
  isMaster = false;
  listOrders: any[];
  exceedsAvailable = false;
  valuePurchase: number;
  block : boolean;
  field: Property;
  dataEntity: DataEntity;
  group: string;
  item: any;

  setConfig(field: Property, dataEntity: DataEntity, group: string, item: any) {
    this.field = field;
    this.dataEntity = dataEntity;
    this.group = group;
    this.item = item;
  }

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private graphqlService: AdfiGraphqlService,
    public sLoading: LoadingService,
    private adfiGrowlService: AdfiGrowlService,
    private aRoute: ActivatedRoute,
    private adfiService: AdfiService,
    private matDialog: MatDialog,
    private navRouteService: NavRouteService

  ) {
    this.formAssets = formBuilder.group({
      typeProduct: ['', Validators.required,],
      description: ['', [Validators.required, Validators.maxLength(700)]],
      value: ['', [Validators.required, Validators.min(1)]],
      withMark: [''],
      mark: ['', [Validators.required,  this.objectValidator]],
      withSerial: [''],
      serialNumber: ['', [Validators.required, Validators.maxLength(70), Validators.minLength(6)]],
      quantity: ['', [Validators.required, Validators.min(1)]],
      orders: ['', Validators.required]
    });
  }

  async ngOnInit(): Promise<void> {
    this.sLoading.show();
    this.id = this.aRoute.snapshot.paramMap.get('id');
    this.block = this.adfiService.validPermission('BlockingPlatform', 'lock', PeriodState.NO_STATUS); 
    this.canAdd = this.adfiService.validPermission('ActivoFijo', Permission.ADD, PeriodState.NO_STATUS); 
    this.getPaymentOrder();
  }

  cancel() {
    this.canGenerate = false;
    this.formAssets.reset();
  }

  addItem() {
    this.canGenerate = true;
  }

  save(form: FormGroupDirective) {
    const content = 'Por favor verifique que la información ingresada sea correcta. <br><b>La veracidad de los datos registrados es <u>responsabilidad</u> del usuario.</b>';
    let warnings = this.formAssets.get('typeProduct')?.value.account._id == 511114 ? [{ fieldName: 'inventoryType', warning: 'El elemento, de acuerdo con el tipo de artículo seleccionado, será clasificado como CONSUMO.'}] : [];
    const data: ConfirmDialogData = {
      title: '¿Desea guardar la información?',
      content,
      action: ENUM_ACTIONS.CREATE,
      warnings
    };
    const dialog = this.dialog.open(ConfirmDialogComponent, {
      data
    });
    dialog.componentInstance.dialogRef.afterClosed().subscribe(async (asset) => {
      if (asset) {
        const quantity = this.formAssets.get('quantity').enabled ? Number(this.formAssets.get('quantity').value) : 1;

        if (!this.masterId) {
          const availability = Number((this.paymentOrder.value - this.totalAsset).toFixed(2));
          let value = 0;
          if (this.formAssets.get('typeProduct')?.value && this.formAssets.get('typeProduct')?.value.account._id !== 511114) {
              value = Number((this.valuePurchase * quantity).toFixed(2));
          }else {
            value = Number((this.valuePurchase).toFixed(2));
          }
          if (value > availability) {
            this.adfiGrowlService.error('Error', 'El valor del bien es mayor al disponible en la Orden de Pago ' + AdfiUtil.formatText(availability.toString(), PropertyTypes.CURRENCY));
            return;
          }
        }
        if (quantity > 1 && this.formAssets.get('typeProduct')?.value && this.formAssets.get('typeProduct')?.value.account._id !== 511114 && !this.formAssets.get('withSerial').value) {
            this.adfiGrowlService.error('Error', 'Recuerde que no se permite el uso de números de serial duplicados. Los elementos deben registrarse individualmente.');
            return;
        }
        this.sLoading.show();
        const continueProcess = (orderId, data): Promise<void> => {
          return new Promise((resolve, reject) => {
          const next = () => {
                  this.adfiGrowlService.info('Finalizado', 'Movimiento agregado correctamente');
                  resolve();
          };
          const error = (err) => {
            this.adfiGrowlService.error('Error', 'No es posible relacionar el activo con la Orden de Pago. Por favor, comuníquese con la Mesa de Ayuda para recibir asistencia.');
            this.sLoading.hide();
            reject(err);
          };
             this.graphqlService.createEntity('AssetsPaymentOrder',
                {
                  asset: data.id,
                  paymentOrder: orderId
                }, undefined, { next, error });

          });
        };
        if (quantity > 0) {
          const selectedOrders = (this.formAssets.get('orders').value || []).sort((a, b) => Number(a.available) - Number(b.available));
          let balance = this.paymentOrder?.value - this.totalAsset;
          let mainFinish = false;
          const createAsset = (form: FormGroupDirective, quantity): Promise<void> => {
            return new Promise((resolve, reject) => {
           const next = async (data) => {
            if (this.masterId) {
                if (balance >= 0) balance -= this.valuePurchase;
              if (!mainFinish) {
                if (balance < 0) {
                  mainFinish = true;
                  await continueProcess(`/api/payment_orders/${this.id}`, data);
                } else {
                  mainFinish = balance < 0.00001;
                  await continueProcess(`/api/payment_orders/${this.id}`, data);
                }
              }
              if (mainFinish && selectedOrders.length > 0) {
                for (let index = 0; index < selectedOrders.length; index++) {
                  if (selectedOrders[index].available > 0) {
                    if ((Math.abs(balance) <= this.valuePurchase) && (Math.abs(balance) >= selectedOrders[index].available)) {
                      await continueProcess(`/api/payment_orders/${selectedOrders[index].id}`, data);
                      balance = selectedOrders[index].available -= Math.abs(balance);
                      selectedOrders[index].available = 0;
                      if(Math.abs(balance) == this.valuePurchase) break;
                    } else {
                      if (balance < 0){
                        await continueProcess(`/api/payment_orders/${selectedOrders[index].id}`, data);
                        balance = selectedOrders[index].available -= Math.abs(balance);
                        break;
                      }else if (balance !== 0) {
                        await continueProcess(`/api/payment_orders/${selectedOrders[index].id}`, data);
                        balance = selectedOrders[index].available -= this.valuePurchase;
                        break;
                      }
                      
                    }
                  }
                }
              }

            } else {
              await continueProcess(`/api/payment_orders/${this.id}`, data);
            }
            resolve();
          };
          const error = (err) => {
            this.cancel();
            this.sLoading.hide();
            this.adfiGrowlService.errorMessage(err);
            reject(err);
          };
              const period = this.adfiService.periods.find(p => p.estado === "A");
              const now = period.year < (new Date()).getFullYear() ? new Date(period.year, 11, 30) : new Date();
              now.setHours(0,0,0,0);
             this.graphqlService.createEntity('ActivoFijo',
                {
                  origen: "COMPRA",
                  typeProduct: form.control.get('typeProduct').value.id,
                  descripcion: form.control.get('description').value,
                  fechaFactura: now.toUTCString(),
                  valorCompra: this.value,
                  cantidad: quantity,
                  noSerial: form.control.get('withSerial').enabled ? form.control.get('withSerial').value ? form.control.get('withSerial').value :false : false,
                  nroSerial: form.control.get('withSerial').value ? "NO APLICA" : form.control.get('serialNumber').value,
                  thirdCheck: form.control.get('withMark').enabled ? form.control.get('withMark').value ? form.control.get('withMark').value : false : false,
                  trademarkRef: form.control.get('withMark').value ? null : form.control.get('mark').value.id,
                  estadoV: "BUENO",
                  third: this.paymentOrder.third.id,
                  base64File: []
                }, undefined, { next, error });
            });
          };
          if (this.formAssets.get('typeProduct')?.value && this.formAssets.get('typeProduct')?.value.account._id !== 511114) {
            for (let index = 0; index < quantity; index++) {
               await createAsset(form, 1);
            }
          }else {
             await createAsset(form, quantity);
          }
            this.canGenerate = false;
            this.getTotalAsset();
            this.formAssets.reset();
            this.sLoading.hide();
        }
      }
    });
  }

  async getPaymentOrder() {
    const next = (data) => {
      this.paymentOrder = data;
      if(this.paymentOrder.register && this.paymentOrder.register.masterRegister){
         this.isMaster = true;
         this.masterId = this.paymentOrder.register.masterRegister._id;
      }
      if (this.paymentOrder.ppeEmployee) {
        this.canUploadCertificate = true;
      }else{
        this.getParOper();
        this.configForm();
      }
      this.getTotalAsset();
    };
    const error = (e) => {
      this.adfiGrowlService.errorMessage(e, 'Error al cargar los registros');
    };
    this.graphqlService.getOneEntity("paymentOrder", "item{idPar} third{id} register{masterRegister{_id}} value ppeEmployee{name}", `/api/payment_orders/${this.id}`, undefined, { next, error });
  }

  async getParOper() {
    const next = (data) => {
      if (data) {
        if (data.accountItemDb === '5111140101') this.isConsumption = true;
        if (this.isMaster) {
          this.adfiService.get(`/api/get/master-assets/${this.masterId}`).subscribe((data: any) => {
            if (data) {
              let orders = data[0].flat()
                .filter(order => Number(order.AVAILABLE) > 0 && order.N_ID !== this.id);
              if (!this.isConsumption) {
                orders = orders.filter(order => order.ACCOUNT !== '5111140101');
              }
              this.listOrders = orders.map(order => ({
                id: order.N_ID,
                available: order.AVAILABLE,
                name: `${order.V_MINIPRESU}-${order.V_NOMBRE},Orden de pago ${order.PRORD_N_NUMORD}, Saldo disponible: ${Number(order.AVAILABLE).toLocaleString('es-CO', { style: 'currency', currency: 'COP' })}`,
                account: order.ACCOUNT
              }));
            }
          });
        }
        this.sLoading.hide();
      }
    };
    const error = (e) => {
      this.adfiGrowlService.errorMessage(e);
      this.sLoading.hide();
    };
    this.graphqlService.getOneEntity('parOper', 'accountItemDb', `/api/par_opers/id=${this.paymentOrder.item.idPar};period=${this.adfiService.user.period}`, undefined, {next, error});
  }

  getTotalAsset() {
    if (!this.assetId && this.assetsTable) {
        this.assetId = this.assetsTable.data.find(item => item.data?.cancellationDate == null)?._id;
    }
    const next = (d) => {
        this.totalAsset = d.total;
        this.calculateAvailability();
        this.isLoading = true;
        this.sLoading.hide();
      };
      const error = (e) => {
          this.adfiGrowlService.errorMessage(e);
      };
      this.graphqlService.createEntity('Summation', {
          nameClass: 'MovimientoBienes\\AssetsPaymentOrder',
          filters: JSON.stringify({paymentOrder: this.id}),
          actions: 'value',
      }, 'total', {next, error});
  }

  preventSubmit(event: KeyboardEvent): void {
    event.preventDefault();
  }

  async getTypeProduct() {
    const filter = 'isEnabled: true';
    const max = await this.graphqlService.countEntity("typeProducts", filter);
    const next = (data) => {
      if (this.isConsumption) {
        this.listTypesProduct = data.filter(value => value.account._id === 511114);
      } else  {
        this.listTypesProduct = data;
      }
      this.listTypesProductFiltered = this.listTypesProduct;
    };
    const error = (e) => {
      this.adfiGrowlService.errorMessage(e, 'Error al cargar los tipos de artículos');
    };
    this.graphqlService.getEntity("typeProducts", "accountUnspsc{description} account{_id} withMark withSerial", max, filter, { next, error });
  }

  async getMark() {
    const max = await this.graphqlService.countEntity("trademarks", '');
    const next = (data) => {
      this.listMarks = data;
      this.listMarksFiltered = this.listMarks;
    };
    const error = (e) => {
      this.adfiGrowlService.errorMessage(e, 'Error al cargar las marcas');
    };
    const aux = this.graphqlService.getEntity("trademarks", "trademarkName", max, '', { next, error });
  }

    private configForm() {
    this.listMarks = [];
    this.formAssets.get('typeProduct').valueChanges.subscribe((value) => {
      if (typeof(value) !== 'object') {
        this.listTypesProductFiltered = this.listTypesProduct.filter(item => item.accountUnspsc.description.toLowerCase().includes(value.toLowerCase()));
      }else if (value) {
        value.withMark ? this.formAssets.get('withMark').disable() : this.formAssets.get('withMark').enable();
        value.withSerial ? this.formAssets.get('withSerial').disable() : this.formAssets.get('withSerial').enable();
        this.formAssets.get('quantity').enabled ?? this.formAssets.get('quantity').disable();
      }
    });
    this.formAssets.get('withMark').valueChanges.subscribe((value) => {
      value === true ? this.formAssets.get('mark').disable() : this.formAssets.get('mark').enable();
    });
    this.formAssets.get('withSerial').valueChanges.subscribe((value) => {
      if(value === true){
        if(this.formAssets.get('serialNumber').enabled) this.formAssets.get('serialNumber').disable();
        this.formAssets.get('quantity').enable();
      } else{
        if(this.formAssets.get('serialNumber').disabled) this.formAssets.get('serialNumber').enable();
        if(this.formAssets.get('quantity').enabled) this.formAssets.get('quantity').disable();
      } 
    });
    this.formAssets.get('quantity').valueChanges.subscribe(val => {
      if(this.formAssets.get('quantity').enabled && val > 0) {
        this.validateValue();
        if (this.formAssets.get('orders').enabled) {
          this.validateOrders();
        }
      }
    });
    this.formAssets.get('mark').valueChanges.subscribe(val => {
      if (typeof(val) !== 'object') {
        this.listMarksFiltered = this.listMarks.filter(item => item.trademarkName.toLowerCase().includes(val.toLowerCase()));
      }
    });
    if (this.isMaster) {
      this.formAssets.get('orders').valueChanges.subscribe((orders) => {
        this.validateOrders();
      });
    } else {
      this.formAssets.get('orders').disable();
    }
  }

  validateValue() {
    const quantity = (this.formAssets.get('quantity').enabled && this.formAssets.get('quantity').value && this.formAssets.get('quantity').value > 0) ? Number(this.formAssets.get('quantity').value) : 1;
    if (this.formAssets.get('typeProduct')?.value && this.formAssets.get('typeProduct')?.value.account._id !== 511114) {
      this.valuePurchase = this.value;
    } else {
      this.valuePurchase = this.value * quantity;
    }
    if (this.isMaster) {
      const availableOrder = Number((this.paymentOrder?.value - this.totalAsset).toFixed(2));
      this.exceedsAvailable = (this.value * quantity) > availableOrder;
      if (this.exceedsAvailable == true && this.formAssets.get('orders').disabled) {
        this.formAssets.get('orders').enable();
      } else if (!this.exceedsAvailable && this.formAssets.get('orders').enabled) {
        this.formAssets.get('orders').disable();
      }
    }
  }

 validateOrders() {
    const selectedOrders = this.formAssets.get('orders').value || [];
    if (selectedOrders.length > 0) {
      const totalAvailableOrders = selectedOrders.reduce((sum, order) => sum + Number(order.available), 0);
      let valuePurchase = 0;
      if (this.formAssets.get('typeProduct')?.value && this.formAssets.get('typeProduct')?.value.account._id !== 511114) {
          const quantity = (this.formAssets.get('quantity').enabled && this.formAssets.get('quantity').value && this.formAssets.get('quantity').value > 0) ? Number(this.formAssets.get('quantity').value) : 1;
          valuePurchase = Number(((this.valuePurchase * quantity) - (this.paymentOrder?.value - this.totalAsset)).toFixed(2));
      }else {
         valuePurchase = Number((this.valuePurchase - (this.paymentOrder?.value - this.totalAsset)).toFixed(2));        
      }
      if (totalAvailableOrders < valuePurchase) {
        this.formAssets.get('orders').setErrors({ moreOrders: true });
      }

      if (selectedOrders.length > 1 && selectedOrders.some(order => order.available >= valuePurchase)) {
        this.formAssets.get('orders').setErrors({ noMoreOrders: true });
      }
      let available = 0;
      for (let i = 0; i < selectedOrders.length; i++) {
        available += Number(selectedOrders[i].available);
        let position = i + 1;
        if (available >= valuePurchase && position < selectedOrders.length) {
          this.formAssets.get('orders').setErrors({ noMoreOrders: true });
        }
      }
    }
  }

  fireCurrency(value: number) {
    if (!isNaN(value)) {
      this.value = value ? value : 0;
      this.validateValue();
      if (this.formAssets.get('orders').enabled) {
        this.validateOrders();
      }
    }
  }

  selectSupervisor() {
    const customData: any = { id: this.paymentOrder.id };
    const dialog = this.matDialog.open(FormComponent, {
      data: {
        entityName: 'PaymentOrder',
        module: 'Egresos',
        group: 'OPADDASSET',
        customData,
        item: this.paymentOrder.id,
        customTitle: 'Seleccionar Delegado Recibido',
        action: ENUM_ACTIONS.EDIT
      } as DataEntity
    });
    dialog.beforeClosed().subscribe((event) => {
      if (event) {
        this.reloadData.emit();
      }
    });
  }

  onButtonClick() {
    if (this.isMaster) {
      this.navRouteService.navigate('/movimiento-bienes/maestro-bienes/1/' + this.masterId);
    } else {
      this.navRouteService.navigate('list/ZXNGODl4cUsrZHNxTlFBR1Rkc05lZz09/Wjl0NC9SK0M3OUE9');
    }
  }

  calculateAvailability() {
    this.availableBalance = Number((this.paymentOrder?.value - this.totalAsset).toFixed(2));
    if (this.availableBalance > 0) {
      if(!this.listTypesProduct?.length) this.getTypeProduct();
      if(!this.listMarks?.length) this.getMark();
    }
  }
  
  calculateTotal() {
    return (this.value * this.formAssets.get('quantity').value).toFixed(2);  
  }

  displayFn(option: any): string {
    return option ? option.__typename === 'TypeProduct' ? option.accountUnspsc.description : option.trademarkName : '';
  }

  objectValidator(control: AbstractControl) {
    const value = control.value;

    if (!value || typeof value !== 'object') {
      return { notObject: true };
    }

    return null;
  }

  reload() {
    this.assetsTable.reload();
  }
}
